import React, { Component } from 'react';
import Navbar from 'components/NavOnScroll';
import Footer from 'components/Footer';
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import Session from 'components/Session';
import styles from './StaticContainer.scss';// to import local scss fle

class StaticContainer extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
  }
  constructor(props) {
    super(props);
    this.state = {
      value: '',
    };
  }
  render() {
    return (
      <div className={styles.container}>
        <Navbar {...this.props} />
        {this.props.children}
        <Footer />
      </div>
    );
  }
}

export default Session(StaticContainer);



// WEBPACK FOOTER //
// ./src/components/StaticContainer/StaticContainer.js